import React, { useState, forwardRef, useImperativeHandle, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Body, Radio, TextField } from '@walmart-web/livingdesign-components';
import style from './ScReferral.module.css';
import { updateReferralInfo, updateReferralResponse } from '../../../../redux/ScRefferals/slice';

const ScReferral = forwardRef((props, ref) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const refferalName = useSelector((state) => state.scRefferals.referrals.referrerName ? state.scRefferals.referrals.referrerName : state.account.data.auth.referrerName);
    const [selectedOption, setSelectedOption] = useState(refferalName ? 11 : '');
    const [referredAssociateName, setReferredAssociateName] = useState(refferalName || '');

    const onRadioChange = (e) => {
        const value = Number(e.target.value);
        setSelectedOption(value);
        if (value === 12) {
            setReferredAssociateName(null);
            dispatch(updateReferralInfo(null));
        }
        dispatch(updateReferralResponse(value));
    };
    const onAssociateNameChange = (e) => {
        const name = e.target.value;
        setReferredAssociateName(name);
        dispatch(updateReferralInfo(name));
    };

    useImperativeHandle(ref, () => ({
        shouldDisableContinue: () => {
            if (selectedOption === '') {
                return true;
            }
            if (selectedOption === 11) {
                return referredAssociateName === '';
            }
            return false;
        }
    }));

    useEffect(() => {
        if (props.handleDisableButton) {
            const isDisabled =
                selectedOption === '' || (selectedOption === 11 && referredAssociateName === '');
            props.handleDisableButton(isDisabled);
        }
    }, [selectedOption, referredAssociateName, props]);

    return (
        <div className={style.page}>
            {props.editProfile === undefined && (
                <>
                    <Body as="p" size="Large" weight={700}>
                        {t('scReferral.title')}
                    </Body>
                    <fieldset className={style.fieldSet}>
                        <legend className={style.legend}>
                            <Body as="p" size="medium" weight={400}>
                                {t('scReferral.referralText1')}
                            </Body>
                        </legend>
                        <Radio
                            checked={selectedOption === 11}
                            value={11}
                            onChange={onRadioChange}
                            label={t('general.yes')}
                        />
                        <Radio
                            checked={selectedOption === 12}
                            value={12}
                            onChange={onRadioChange}
                            label={t('general.no')}
                        />
                        {selectedOption === 11 && (
                            <>
                                <Body as="p" size="medium" weight={400}>
                                    {t('scReferral.referralText')}
                                </Body>
                                <TextField
                                    name="associateName"
                                    placeholder={referredAssociateName ? referredAssociateName : t('scReferral.referralName')}
                                    className={style.inputField}
                                    onChange={onAssociateNameChange}
                                    value={referredAssociateName}
                                    aria-label={t('scReferral.referralName')}
                                />
                            </>
                        )}
                    </fieldset>
                </>
            )}
        </div>
    );
});

export default ScReferral;